import './instrument'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { setupAutoUpdateManager } from './lib/pwa/autoUpdateManager'

setupAutoUpdateManager()

createRoot(document.getElementById('root')!).render(
  <App />,
)
